import {ChangeDetectionStrategy, Component, inject, ViewEncapsulation} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {Store} from '@ngrx/store';
import {SbbButton, SbbSecondaryButton} from '@sbb-esta/lyne-angular/button';
import {SbbCheckbox} from '@sbb-esta/lyne-angular/checkbox';
import {SbbDialogContent, SbbDialogTitle, SbbDialogActions, SbbDialogRef, SbbDialogCloseButton} from '@sbb-esta/lyne-angular/dialog';
import {SbbLink} from '@sbb-esta/lyne-angular/link';
import {NotificationHelper} from '../../root-store/notification/notification-helper';
import {notificationCreate} from '../../root-store/notification/notification.actions';
import {DateService} from '../../services/date/date.service';
import {changeUserProfileSettings} from '../auth-store/auth.actions';
import {selectUserProfileSettings} from '../auth-store/auth.selectors';

@Component({
  selector: 'app-session-analyse',
  templateUrl: './session-analyse.component.html',
  styleUrls: ['./session-analyse.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [SbbButton, SbbSecondaryButton, SbbCheckbox, ReactiveFormsModule, SbbLink, SbbDialogContent, SbbDialogTitle, SbbDialogActions, SbbDialogCloseButton]
})
export class SessionAnalyseComponent {
  // == Injection ==
  private readonly store = inject(Store);
  private readonly dialogRef = inject<SbbDialogRef<SessionAnalyseComponent>>(SbbDialogRef);

  // == Form Controls ==
  public readonly sessionForm = new FormGroup({
    enabled: new FormControl(false)
  });

  // == Signals ==
  private readonly settings = this.store.selectSignal(selectUserProfileSettings);

  enableSessionRecording(): void {
    const nowUtc = DateService.dateTimeToUTCDateTime(new Date());
    this.store.dispatch(
      changeUserProfileSettings({
        payload: {
          ...this.settings(),
          sessionRecording: {
            datumZuletztGeaendert: nowUtc,
            sessionRecordingAktiv: true
          }
        }
      })
    );

    this.store.dispatch(
      notificationCreate({
        notification: NotificationHelper.createCDNotification({
          type: 'info',
          title: $localize`:@@NOTIFICATION_SESSION_RECORDING_ACTIVATED:Vielen Dank für Ihre Teilnahme am Verbesserungsprogramm.`,
          showInNotificationCenter: false
        })
      })
    );
    this.dialogRef.close(true);
  }

  disableSessionRecording(): void {
    const nowUtc = DateService.dateTimeToUTCDateTime(new Date());

    this.store.dispatch(
      changeUserProfileSettings({
        payload: {
          ...this.settings(),
          sessionRecording: {
            datumZuletztGeaendert: nowUtc,
            sessionRecordingAktiv: false
          }
        }
      })
    );
    this.dialogRef.close(false);
  }

  onSubmit() {
    if (this.sessionForm.value.enabled) return this.enableSessionRecording();
    this.disableSessionRecording();
  }

  onAbort(): void {
    this.dialogRef.close(false);
  }
}
